import { ChartEventBadgeType } from '../../../constants/common'
import { getChartEventDividendsSvgString } from './dividends'
import { getChartEventEarningsFutureSvgString } from './earnings-future'
import { getChartEventEarningsNegativeSvgString } from './earnings-negative'
import { getChartEventEarningsNeutralSvgString } from './earnings-neutral'
import { getChartEventEarningsPositiveSvgString } from './earnings-positive'
import { getChartEventSplitSvgString } from './split'

export const chartBadgeSvgByType = Object.freeze({
  [ChartEventBadgeType.Split]: getChartEventSplitSvgString,
  [ChartEventBadgeType.Dividends]: getChartEventDividendsSvgString,
  [ChartEventBadgeType.EarningsPositive]: getChartEventEarningsPositiveSvgString,
  [ChartEventBadgeType.EarningsNegative]: getChartEventEarningsNegativeSvgString,
  [ChartEventBadgeType.EarningsNeutral]: getChartEventEarningsNeutralSvgString,
  [ChartEventBadgeType.EarningsFuture]: getChartEventEarningsFutureSvgString,
})
